// src\components\CustomLoader.tsx
import React from "react";
import { CircularProgress, Box } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "@/stores";

const AUTH_INLINE_LOADING_PATHS = new Set([
  '/',
  '/customer/login',
  '/forgot-password',
  '/login',
  '/reset-password',
  '/verify-login-otp',
  '/verify-otp',
]);

const getNormalizedPathname = () => {
  const pathname = window.location.pathname.replace(/\/+$/, '');
  return pathname || '/';
};

const Loader: React.FC = () => {
  const activeRequests = useSelector((state: RootState) => state.loading.activeRequests);
  const usesInlineButtonLoading = AUTH_INLINE_LOADING_PATHS.has(
    getNormalizedPathname(),
  );
  const showLoader = activeRequests > 0 && !usesInlineButtonLoading;

  if (!showLoader) return null;

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgcolor="rgba(255,255,255,0.5)"
      zIndex={9999}
    >
      <CircularProgress />
    </Box>
  );
};

export default Loader;
